/* Native SearchScreen parity for the mobile Shopify surface.
   Catalogue reads only: Shopify section HTML + the public search-v2 function. */
(function () {
  var root = document.querySelector('[data-gettmi-search-app]');
  if (!root) return;

  var MAX_QUERY_LENGTH = 120;
  var SEARCH_TIMEOUT_MS = 6000;
  var VERB_HINT = 'GETTMI a black dress for a wedding';
  var VERB_PREFIX = /^(gettmi|getmi|gettme|getme)|^(get me|gett mi|get tmi)\b/i;
  var EVENT_OCCASIONS = [
    'wedding-guest', 'races', 'christmas-party', 'nye', 'gala', 'prom',
    'engagement-party', 'hen-party', 'christening', 'baby-shower', 'graduation',
    'birthday', 'cocktail'
  ];
  var app = {
    sectionId: root.dataset.sectionId,
    searchUrl: root.dataset.searchUrl,
    form: root.querySelector('[data-gettmi-search-form]'),
    composer: root.querySelector('[data-gettmi-search-composer]'),
    input: root.querySelector('[data-gettmi-search-input]'),
    camera: root.querySelector('[data-gettmi-search-camera]'),
    compact: root.querySelector('[data-gettmi-search-compact]'),
    count: root.querySelector('[data-gettmi-search-count]'),
    ghost: root.querySelector('[data-gettmi-search-ghost]'),
    suggestions: root.querySelector('[data-gettmi-search-suggestions]'),
    intro: root.querySelector('[data-gettmi-search-intro]'),
    trending: root.querySelector('[data-gettmi-search-trending]'),
    browseLabel: root.querySelector('[data-gettmi-search-browse-label]'),
    found: root.querySelector('[data-gettmi-search-found]'),
    foundCount: root.querySelector('[data-gettmi-search-found-count]'),
    refine: root.querySelector('[data-gettmi-search-refine]'),
    refineChips: root.querySelector('[data-gettmi-search-refine-chips]'),
    door: root.querySelector('[data-gettmi-search-door]'),
    doorFeature: root.querySelector('[data-gettmi-search-door-feature]'),
    doorRsvp: root.querySelector('[data-gettmi-search-door-rsvp]'),
    doorDupe: root.querySelector('[data-gettmi-search-door-dupe]'),
    doorPieces: root.querySelector('[data-gettmi-search-door-pieces]'),
    verbHint: root.querySelector('[data-gettmi-search-verb-hint]'),
    results: root.querySelector('[data-gettmi-search-results]'),
    grid: root.querySelector('[data-gettmi-search-grid]'),
    empty: root.querySelector('[data-gettmi-search-empty]'),
    emptyTitle: root.querySelector('[data-gettmi-search-empty-title]'),
    emptyText: root.querySelector('[data-gettmi-search-empty-text]'),
    teach: root.querySelector('[data-gettmi-search-teach]'),
    retry: root.querySelector('[data-gettmi-search-retry]'),
    end: root.querySelector('[data-gettmi-search-end]'),
    endText: root.querySelector('[data-gettmi-search-end-text]'),
    heartIcon: root.dataset.heartIcon || ''
  };

  var STARTER_QUERIES = [
    'dress for a summer wedding',
    'black dress that hides bloating',
    "heels that won't kill me",
    'outfit for drinks with the girls',
    'white dress but not bridal',
    'birthday dress under £150',
    'winter wedding guest dress',
    'what to wear to the races',
    'date night outfit',
    'office dress for work',
    'holiday clothes for a beach trip',
    'new years eve party dress',
    'festival outfit',
    'graduation dress',
    'dress to hide my tummy',
    'supportive dress for a bigger bust',
    'something that hides my arms',
    'comfortable shoes i can dance in',
    'petite friendly midi dress',
    'long dress for tall girls',
    'cheap going out top',
    'dresses under £50',
    'clean girl aesthetic outfit',
    'old money quiet luxury look',
    'coquette feminine dress',
    'edgy night out look',
    'statement going out top',
    'effortless throw on summer dress',
    'red maxi dress',
    'little black dress',
    'pastel dress for a baby shower',
    'heels but nothing too high',
    "going out dress that isn't black",
    'cute brunch outfit on a budget',
    'first date casual but cute',
    'gold heels',
    'cocktail dress for an autumn party',
    'cosy knit jumper for winter',
    'green dress for a wedding',
    'matching co ord set',
    'outfit for capri',
    'something for mykonos',
    'apres ski outfit',
    'what to wear in dubai',
    'ibiza holiday outfit',
    'hen do dress',
    'girls trip outfit',
    'meet the parents outfit',
    'office siren dress',
    'south of france outfit'
  ];
  var STARTER_BRANDS = [
    'aimee kestenberg', 'albert coll', 'almada label', 'alo yoga', 'anine bing',
    'anna october', "annie's ibiza", 'arcina ori', 'attire the studio',
    'aureum collective', 'bad n bare', 'bananhot', 'beaufille', 'bec + bridge',
    'because of alice', 'bevza', 'bondi born', 'bumpsuit', 'by far', 'by malina',
    'bydee', 'conner ives', 'csb', 'cultnaked', 'delavali', 'dvf',
    'faithfull the brand', 'frankies bikinis', 'god save queens', 'henne',
    'holland cooper', 'hope macaulay', 'iamgia', 'khanums', 'kukhareva', 'l.a-s',
    'leset', 'lie studio', 'loulou de saison', 'loveshackfancy', 'lurelly', 'maje',
    'marina raphael', 'marni', 'mars the label', 'max mara', 'may mashiah',
    'meshki', 'misha', 'missoni', 'monday swimwear', 'musier paris', 'nanushka',
    'nippies', 'nood', 'nootka', 'nubra', 'nuuds', 'odd muse', 'one mile',
    'oner active', 'p.e nation', 'parke', 'patbo', 'posse', 'poster girl',
    'priceless', 'rat & boa', 'reasn', 'rixo', 'roar cruise', 'rohe',
    'romeo waiting', 'rouje', 'rue sophie', 'sabo skirt', 'same los angeles',
    'sandy liang', 'sasha therese', 'sir.', 'slip', 'sporty & rich', 'st. agni',
    'strathberry', 'tala', 'the jude', 'toteme', 'victoria beckham',
    'weworewhat', 'zadig & voltaire'
  ];
  var phrases = STARTER_QUERIES
    .map(function (text) { return { text: text, popularity: 2 }; })
    .concat(STARTER_BRANDS.map(function (text) { return { text: text, popularity: 3 }; }));

  var state = {
    runId: 0,
    term: app.input.value.trim(),
    source: app.input.value.trim() ? 'shopify' : 'shopify',
    total: Number(app.grid && app.grid.dataset.total || 0),
    loaded: app.grid ? app.grid.querySelectorAll('[data-gettmi-search-card]').length : 0,
    nextUrl: app.grid && app.grid.dataset.nextUrl || '',
    nextOffset: null,
    hasMore: Boolean(app.grid && app.grid.dataset.nextUrl),
    loadingMore: false,
    priority: 0,
    touchX: null,
    initialHtml: app.input.value.trim() ? '' : app.grid.innerHTML,
    initialTotal: app.input.value.trim() ? 0 : Number(app.grid.dataset.total || 0),
    initialNextUrl: app.input.value.trim() ? '' : app.grid.dataset.nextUrl || '',
    sideDoor: '',
    lastEventDoorTerm: '',
    scrollFrame: 0
  };

  function supabaseConfig() {
    var element = document.querySelector('[data-gettmi-supabase]');
    return element ? {
      url: element.dataset.supabaseUrl,
      key: element.dataset.supabaseKey
    } : null;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function productUrl(handle) {
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return shopRoot + 'products/' + encodeURIComponent(handle);
  }

  function formatPrice(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: amount % 1 ? 2 : 0,
      maximumFractionDigits: amount % 1 ? 2 : 0
    }).format(amount);
  }

  function cardHtml(product, position) {
    var why = ((product.why || product.search_v2 && product.search_v2.why) || [])
      .slice(0, 2)
      .map(function (value) {
        return String(value).split(':').pop().replace(/-/g, ' ');
      });
    var whyHtml = why.length
      ? '<span class="gettmi-search-card__why">' +
        escapeHtml(why.join(', ').replace(/^./, function (letter) { return letter.toUpperCase(); })) +
        '</span>'
      : '';
    var hero = position === 7 || position === 14;
    var url = productUrl(product.handle || '');
    return (
      '<li class="gettmi-search-card' + (hero ? ' gettmi-search-card--hero' : '') + '" data-gettmi-search-card data-product-handle="' + escapeHtml(product.handle || '') + '">' +
        '<a class="gettmi-search-card__link" href="' + escapeHtml(url) + '">' +
          '<span class="gettmi-search-card__image-wrap">' +
            (product.image
              ? '<img class="gettmi-search-card__image" src="' + escapeHtml(product.image) + '" alt="" loading="' + (position > 4 ? 'lazy' : 'eager') + '">'
              : '<span class="gettmi-search-card__placeholder"></span>') +
          '</span>' +
          whyHtml +
          '<span class="gettmi-search-card__brand">' + escapeHtml(product.vendor || '') + '</span>' +
          '<span class="gettmi-search-card__name">' + escapeHtml(product.title || '') + '</span>' +
          '<span class="gettmi-search-card__price">' + escapeHtml(formatPrice(product.price)) + '</span>' +
        '</a>' +
        '<button type="button" class="gettmi-heart gettmi-search-card__save" data-gettmi-heart' +
          ' data-handle="' + escapeHtml(product.handle || '') + '"' +
          ' data-title="' + escapeHtml(product.title || '') + '"' +
          ' data-vendor="' + escapeHtml(product.vendor || '') + '"' +
          ' data-path="' + escapeHtml(url) + '"' +
          ' data-image="' + escapeHtml(product.image || '') + '" aria-label="Add to favourites">' +
          '<img src="' + escapeHtml(app.heartIcon) + '" alt="" width="20" height="20">' +
        '</button>' +
      '</li>'
    );
  }

  function paintFavourites() {
    if (window.GettmiFavourites && typeof window.GettmiFavourites.paint === 'function') {
      window.GettmiFavourites.paint();
    }
  }

  function setGridHtml(html) {
    app.grid.classList.remove('is-loading');
    app.grid.innerHTML = html;
    state.loaded = app.grid.querySelectorAll('[data-gettmi-search-card]').length;
    paintFavourites();
  }

  function showSkeletons() {
    app.grid.classList.add('is-loading');
    app.grid.innerHTML = [
      '<li class="gettmi-search-skeleton"></li>',
      '<li class="gettmi-search-skeleton"></li>',
      '<li class="gettmi-search-skeleton"></li>',
      '<li class="gettmi-search-skeleton"></li>'
    ].join('');
    app.results.hidden = false;
    app.empty.hidden = true;
    app.end.hidden = true;
  }

  function showEmpty(error) {
    app.grid.classList.remove('is-loading');
    app.grid.innerHTML = '';
    app.results.hidden = true;
    app.empty.hidden = false;
    app.end.hidden = true;
    app.retry.hidden = !error;
    app.teach.hidden = Boolean(error);
    app.emptyTitle.textContent = error ? 'Search is unavailable.' : 'No matches for that search (yet).';
    app.emptyText.textContent = error
      ? 'We couldn’t reach the catalogue. Check your connection and try again.'
      : 'Try a different colour, fewer details or a broader search.';
  }

  function updateEnd() {
    if (!state.loaded) {
      app.end.hidden = true;
      return;
    }
    app.end.hidden = false;
    if (state.loadingMore) {
      app.endText.textContent = 'LOADING MORE';
    } else if (state.hasMore) {
      app.endText.textContent = 'SCROLL FOR MORE';
    } else {
      app.endText.textContent = 'THAT’S EVERYTHING';
    }
  }

  function showSideDoor(kind) {
    state.sideDoor = kind === 'rsvp' || kind === 'dupe' ? kind : '';
    app.door.hidden = !state.sideDoor;
    app.doorRsvp.hidden = state.sideDoor !== 'rsvp';
    app.doorDupe.hidden = state.sideDoor !== 'dupe';
    app.doorFeature.classList.toggle('is-rsvp', state.sideDoor === 'rsvp');
    app.doorFeature.classList.toggle('is-dupe', state.sideDoor === 'dupe');
    app.doorPieces.hidden = !state.sideDoor || !app.foundCount.textContent;
    app.doorPieces.textContent = app.foundCount.textContent;
    app.found.hidden = Boolean(state.sideDoor) || !app.foundCount.textContent;
  }

  function headlineFor(meta) {
    if (!state.term || !meta) return '';
    if (meta.intent && meta.intent.best_now) return 'MOST WANTED RIGHT NOW';
    if (meta.relaxed_colour || meta.relaxed_price) return 'CLOSE MATCHES';
    return state.source === 'v2' ? 'STRONG MATCHES' : 'MATCHES';
  }

  function refinementOptions(products, meta) {
    if (!state.term || state.source !== 'v2' || !products.length) return [];
    var intent = meta && meta.intent || {};
    var options = [];
    var prices = products.map(function (product) { return Number(product.price); })
      .filter(function (price) { return Number.isFinite(price) && price > 0; })
      .sort(function (left, right) { return left - right; });
    if (prices.length >= 4) {
      var median = prices[Math.floor(prices.length / 2)];
      var cap = Math.floor((median * 0.8) / 10) * 10;
      if (cap >= 250 && (!intent.price_max || cap < Number(intent.price_max))) {
        options.push({ label: 'UNDER £' + cap, suffix: 'under ' + cap });
      }
    }
    var colours = intent.colours || [];
    if (colours.indexOf('black') === -1) options.push({ label: 'IN BLACK', suffix: 'in black' });
    else if (colours.indexOf('red') === -1) options.push({ label: 'IN RED', suffix: 'in red' });
    if ((intent.exclude || []).indexOf('sheer') === -1) {
      options.push({ label: 'MORE COVERED', suffix: 'covered up' });
    }
    return options.slice(0, 3);
  }

  function renderSearchChrome(products, meta) {
    app.foundCount.textContent = headlineFor(meta);
    app.found.hidden = !app.foundCount.textContent || Boolean(state.sideDoor);
    var options = refinementOptions(products, meta);
    app.refine.hidden = !options.length;
    app.refineChips.innerHTML = options.map(function (option) {
      return '<button type="button" data-gettmi-search-refinement="' + escapeHtml(option.suffix) + '">' +
        escapeHtml(option.label) + '</button>';
    }).join('');
    app.doorPieces.textContent = app.foundCount.textContent;
    app.doorPieces.hidden = !state.sideDoor || !app.foundCount.textContent;
  }

  function clearSearchChrome() {
    app.found.hidden = true;
    app.foundCount.textContent = '';
    app.refine.hidden = true;
    app.refineChips.innerHTML = '';
    app.doorPieces.hidden = true;
  }

  function maybeShowRsvp(meta) {
    if (state.sideDoor || state.lastEventDoorTerm === state.term || !meta || !meta.intent) return;
    var occasions = meta.intent.occasions || [];
    if (!occasions.some(function (occasion) { return EVENT_OCCASIONS.indexOf(occasion) !== -1; })) return;
    state.lastEventDoorTerm = state.term;
    showSideDoor('rsvp');
  }

  function publishProducts(products, meta, runId, append) {
    if (runId !== state.runId || !Array.isArray(products) || !products.length) return false;
    if (!append && state.priority > 2) return false;
    var start = append ? state.loaded : 0;
    var html = products.map(function (product, index) {
      return cardHtml(product, start + index + 1);
    }).join('');
    if (append) {
      app.grid.insertAdjacentHTML('beforeend', html);
      state.loaded = app.grid.querySelectorAll('[data-gettmi-search-card]').length;
      paintFavourites();
    } else {
      setGridHtml(html);
    }
    state.total = Number(meta && meta.total_matched || state.loaded);
    state.nextOffset = meta && Number.isFinite(meta.next_offset) ? meta.next_offset : state.loaded;
    state.hasMore = meta && typeof meta.has_more === 'boolean'
      ? meta.has_more
      : state.loaded < state.total;
    state.source = 'v2';
    state.priority = 2;
    app.results.hidden = false;
    app.empty.hidden = true;
    if (!append) {
      renderSearchChrome(products, meta);
      maybeShowRsvp(meta);
    }
    updateEnd();
    return true;
  }

  function publishShopify(sectionData, runId, append) {
    if (runId !== state.runId || !sectionData || !sectionData.html) return false;
    if (!append && state.priority > 1) return false;
    if (append) {
      app.grid.insertAdjacentHTML('beforeend', sectionData.html);
      state.loaded = app.grid.querySelectorAll('[data-gettmi-search-card]').length;
      paintFavourites();
    } else {
      setGridHtml(sectionData.html);
    }
    state.total = sectionData.total;
    state.nextUrl = sectionData.nextUrl;
    state.hasMore = Boolean(sectionData.nextUrl);
    state.source = 'shopify';
    state.priority = 1;
    app.results.hidden = false;
    app.empty.hidden = true;
    if (!append) renderSearchChrome([], { engine: 'shopify' });
    updateEnd();
    return true;
  }

  function fitLabel(value) {
    var labels = {
      'forgiving-midsection': 'forgiving fit',
      'wearable-height': 'walkable heels',
      comfortable: 'comfy',
      'bust-support': 'supportive',
      'arm-coverage': 'with sleeves',
      flattering: 'flattering'
    };
    return labels[value] || String(value || '').replace(/-/g, ' ');
  }

  function intentChips(intent) {
    if (!intent) return [];
    var chips = [];
    function add(label, negative) {
      if (!label || chips.length >= 5 || chips.some(function (chip) { return chip.label === label; })) return;
      chips.push({ label: label, negative: Boolean(negative) });
    }
    add(intent.category);
    (intent.colours || []).slice(0, 2).forEach(function (value) { add(value); });
    (intent.occasions || []).slice(0, 2).forEach(function (value) { add(String(value).replace(/-/g, ' ')); });
    (intent.fit_concerns || []).slice(0, 2).forEach(function (value) { add(fitLabel(value)); });
    if (intent.price_max) add('under £' + intent.price_max);
    (intent.exclude || []).slice(0, 2).forEach(function (value) {
      add('no ' + String(value).replace(/-/g, ' '), true);
    });
    return chips;
  }

  function searchV2(term, offset) {
    var config = supabaseConfig();
    if (!config || !config.url || !config.key) return Promise.reject(new Error('Search configuration unavailable'));
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, SEARCH_TIMEOUT_MS);
    return window.fetch(config.url + '/functions/v1/search-v2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: config.key,
        Authorization: 'Bearer ' + config.key
      },
      body: JSON.stringify({ q: term, limit: 24, offset: offset || 0 }),
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Semantic search unavailable');
      return response.json();
    }).finally(function () {
      window.clearTimeout(timer);
    });
  }

  function sectionUrl(term, pageUrl) {
    var url = new URL(pageUrl || app.searchUrl, window.location.origin);
    if (!pageUrl) {
      if (term) url.searchParams.set('q', term);
      else url.searchParams.delete('q');
      url.searchParams.set('options[prefix]', 'last');
    }
    url.searchParams.set('section_id', app.sectionId);
    return url.toString();
  }

  function fetchShopifySection(term, pageUrl) {
    return window.fetch(sectionUrl(term, pageUrl), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Shopify search unavailable');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = doc.querySelector('[data-gettmi-search-grid]');
      if (!grid) throw new Error('Shopify search response missing grid');
      return {
        html: grid.innerHTML,
        total: Number(grid.dataset.total || grid.querySelectorAll('[data-gettmi-search-card]').length),
        nextUrl: grid.dataset.nextUrl || ''
      };
    });
  }

  function searchHistoryUrl(term) {
    var url = new URL(app.searchUrl, window.location.origin);
    if (term) url.searchParams.set('q', term);
    return url.pathname + url.search;
  }

  function runSearch(term) {
    var cleanTerm = String(term || '').trim().slice(0, MAX_QUERY_LENGTH);
    var runId = state.runId + 1;
    state.runId = runId;
    state.term = cleanTerm;
    state.nextOffset = null;
    state.nextUrl = '';
    state.hasMore = false;
    state.loadingMore = false;
    state.priority = 0;
    clearSearchChrome();
    showSideDoor('');
    if (cleanTerm && VERB_PREFIX.test(cleanTerm) && /\b(the|a) look\b/i.test(cleanTerm)) {
      showSideDoor('rsvp');
    }
    app.intro.hidden = Boolean(cleanTerm);
    app.suggestions.hidden = true;
    app.suggestions.innerHTML = '';
    app.ghost.innerHTML = '';
    window.history.replaceState({}, '', searchHistoryUrl(cleanTerm));

    if (!cleanTerm && state.initialHtml) {
      setGridHtml(state.initialHtml);
      state.total = state.initialTotal;
      state.nextUrl = state.initialNextUrl;
      state.hasMore = Boolean(state.nextUrl);
      state.source = 'shopify';
      state.priority = 1;
      app.results.hidden = false;
      app.empty.hidden = true;
      updateBrowseLabel();
      updateEnd();
      return;
    }

    showSkeletons();
    var published = false;
    var failed = 0;

    var shopifyTerm = cleanTerm.replace(VERB_PREFIX, '').trim() || cleanTerm;
    var fallbackTask = fetchShopifySection(shopifyTerm).then(function (sectionData) {
      if (runId !== state.runId) return;
      if (sectionData.html.trim()) {
        published = publishShopify(sectionData, runId, false) || published;
      }
    }).catch(function () {
      failed += 1;
    });

    var semanticTask = cleanTerm
      ? searchV2(cleanTerm, 0).then(function (data) {
        if (runId !== state.runId) return;
        if (Array.isArray(data.results) && data.results.length) {
          published = publishProducts(data.results, data, runId, false) || published;
        }
      }).catch(function () {
        failed += 1;
      })
      : Promise.resolve();

    Promise.allSettled([fallbackTask, semanticTask]).then(function () {
      if (runId !== state.runId) return;
      if (!published) showEmpty(failed === (cleanTerm ? 2 : 1));
    });
  }

  function loadMore() {
    if (state.loadingMore || !state.hasMore || !state.loaded) return;
    state.loadingMore = true;
    updateEnd();
    var runId = state.runId;
    var task;
    if (state.source === 'v2') {
      task = searchV2(state.term, state.nextOffset || state.loaded).then(function (data) {
        publishProducts(data.results || [], data, runId, true);
      });
    } else {
      task = fetchShopifySection(state.term, state.nextUrl).then(function (sectionData) {
        publishShopify(sectionData, runId, true);
      });
    }
    task.catch(function () {
      state.hasMore = false;
    }).finally(function () {
      if (runId !== state.runId) return;
      state.loadingMore = false;
      updateEnd();
    });
  }

  function rankSuggestions(value) {
    var query = String(value || '').toLowerCase().trim();
    if (!query) return { suggestions: [], ghost: null };
    var lastWord = query.split(' ').pop();
    var ranked = phrases.map(function (phrase) {
      var text = String(phrase.text || '').toLowerCase();
      var tier = text.indexOf(query) === 0
        ? 3
        : text.split(' ').some(function (word) { return word.indexOf(lastWord) === 0; })
          ? 2
          : text.indexOf(query) >= 0 ? 1 : 0;
      return { text: phrase.text, popularity: Number(phrase.popularity || 1), tier: tier };
    }).filter(function (phrase) {
      return phrase.tier && phrase.text.toLowerCase() !== query;
    }).sort(function (left, right) {
      return right.tier - left.tier ||
        right.popularity - left.popularity ||
        left.text.length - right.text.length;
    });
    var suggestions = ranked.slice(0, 5).map(function (phrase) { return phrase.text; });
    var ghost = ranked.find(function (phrase) {
      return phrase.text.toLowerCase().indexOf(query) === 0 && phrase.text.length > query.length;
    });
    return {
      suggestions: suggestions,
      ghost: ghost ? { full: ghost.text, completion: ghost.text.slice(query.length) } : null
    };
  }

  function renderSuggestions() {
    var value = app.input.value;
    var typeahead = rankSuggestions(value);
    app.ghost.innerHTML = typeahead.ghost
      ? '<span class="gettmi-search-composer__ghost-inner"><span class="gettmi-search-composer__ghost-typed">' +
        escapeHtml(value) + '</span>' + escapeHtml(typeahead.ghost.completion) + '</span>'
      : '';
    app.ghost.dataset.full = typeahead.ghost ? typeahead.ghost.full : '';
    if (!typeahead.suggestions.length) {
      app.suggestions.hidden = true;
      app.suggestions.innerHTML = '';
      return;
    }
    app.suggestions.innerHTML =
      (typeahead.ghost ? '<p class="gettmi-search-suggestions__hint">SWIPE RIGHT TO COMPLETE</p>' : '') +
      typeahead.suggestions.map(function (phrase) {
        return '<button type="button" class="gettmi-search-suggestions__row" data-gettmi-suggestion="' +
          escapeHtml(phrase) + '">' + escapeHtml(phrase) + '</button>';
      }).join('');
    app.suggestions.hidden = false;
  }

  function updateComposer() {
    var expanded = app.input.value.length > 0;
    app.composer.classList.toggle('is-expanded', expanded);
    app.count.hidden = !expanded;
    app.count.textContent = app.input.value.length + ' / ' + MAX_QUERY_LENGTH;
    app.intro.hidden = expanded;
    if (!expanded) {
      app.ghost.innerHTML = '';
      app.suggestions.hidden = true;
    }
  }

  function acceptGhost() {
    var full = app.ghost.dataset.full;
    if (!full) return;
    app.input.value = full;
    updateComposer();
    renderSuggestions();
    app.input.focus();
  }

  function updateBrowseLabel() {
    if (!app.browseLabel) return;
    app.browseLabel.textContent = 'BROWSE THE FULL CATALOGUE';
  }

  function tidyTrendingChips(values) {
    var seen = {};
    var usable = (values || []).filter(function (raw) {
      var term = String(raw || '').trim();
      var key = term.toLowerCase();
      if (!term || seen[key] || /^(gettmi(?!\s)|getmi|gettme|getme|gett\s?mi\b|get\s?tmi\b)/i.test(term)) return false;
      seen[key] = true;
      return true;
    }).slice(0, 4);
    if (!usable.some(function (term) { return /^gettmi\s/i.test(term); })) {
      var verb = (values || []).find(function (term) { return /^gettmi\s/i.test(String(term || '').trim()); });
      if (verb) usable[Math.max(0, usable.length - 1)] = String(verb).trim();
    }
    return usable;
  }

  function hydrateTrending() {
    var config = supabaseConfig();
    if (!config || !config.url || !config.key) return;
    window.fetch(config.url + '/functions/v1/search-v2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: config.key,
        Authorization: 'Bearer ' + config.key
      },
      body: JSON.stringify({ mode: 'trending' })
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (data) {
      var chips = tidyTrendingChips((data && data.chips || []).map(function (chip) { return chip && chip.query; }));
      if (!chips.length) return;
      app.trending.innerHTML = chips.map(function (term) {
        return '<button type="button" class="gettmi-search-trending__chip" data-gettmi-search-term="' +
          escapeHtml(term) + '">' + escapeHtml(term) + '</button>';
      }).join('');
    }).catch(function () {
      /* Bundled app terms remain. */
    });
  }

  function warmPhrases() {
    var config = supabaseConfig();
    if (!config || !config.url || !config.key) return;
    window.fetch(config.url + '/functions/v1/search-v2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: config.key,
        Authorization: 'Bearer ' + config.key
      },
      body: JSON.stringify({ mode: 'phrases' })
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.phrases)) return;
      var merged = new Map();
      phrases.concat(data.phrases).forEach(function (phrase) {
        if (phrase && typeof phrase.text === 'string') {
          merged.set(phrase.text, { text: phrase.text, popularity: phrase.popularity || 1 });
        }
      });
      phrases = Array.from(merged.values());
    }).catch(function () {
      /* Bundled app phrases remain. */
    });
  }

  app.form.addEventListener('submit', function (event) {
    event.preventDefault();
    dismissVerbHint();
    runSearch(app.input.value);
  });

  app.input.addEventListener('input', function () {
    showSideDoor('');
    clearSearchChrome();
    updateComposer();
    renderSuggestions();
    if (!app.input.value.trim()) runSearch('');
  });

  app.input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      dismissVerbHint();
      runSearch(app.input.value);
      app.input.blur();
    }
  });

  app.suggestions.addEventListener('click', function (event) {
    var button = event.target.closest('[data-gettmi-suggestion]');
    if (!button) return;
    app.input.value = button.dataset.gettmiSuggestion;
    updateComposer();
    dismissVerbHint();
    runSearch(app.input.value);
  });

  app.trending.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-gettmi-search-term]');
    if (!chip) return;
    app.input.value = chip.dataset.gettmiSearchTerm;
    updateComposer();
    dismissVerbHint();
    runSearch(app.input.value);
  });

  app.composer.addEventListener('touchstart', function (event) {
    state.touchX = event.touches && event.touches[0] ? event.touches[0].clientX : null;
  }, { passive: true });

  app.composer.addEventListener('touchend', function (event) {
    var endX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : null;
    if (state.touchX != null && endX != null && endX - state.touchX > 24) acceptGhost();
    state.touchX = null;
  }, { passive: true });

  app.retry.addEventListener('click', function () {
    runSearch(state.term);
  });

  function dismissVerbHint() {
    app.verbHint.hidden = true;
    try { window.sessionStorage.setItem('gettmi.search.verbHintSeen.v1', '1'); } catch (error) { /* Best effort. */ }
  }

  function searchExample(source) {
    app.input.value = VERB_HINT;
    updateComposer();
    dismissVerbHint();
    runSearch(VERB_HINT, source);
    app.input.focus();
  }

  app.verbHint.addEventListener('click', function () { searchExample('verb_hint'); });
  app.teach.addEventListener('click', function () { searchExample('empty_state_example'); });

  app.camera.addEventListener('click', function () {
    showSideDoor('dupe');
    app.door.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  });

  app.refineChips.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-gettmi-search-refinement]');
    if (!chip) return;
    var base = state.term.replace(/\bunder [£$]?\s?\d+\b/gi, '').replace(/\s+/g, ' ').trim();
    var term = (base + ' ' + chip.dataset.gettmiSearchRefinement).trim();
    app.input.value = term;
    updateComposer();
    runSearch(term);
  });

  app.compact.addEventListener('click', function () {
    var top = root.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: top, behavior: 'smooth' });
    window.setTimeout(function () { app.input.focus(); }, 360);
  });

  function updateCompactSearch() {
    state.scrollFrame = 0;
    var rootTop = root.getBoundingClientRect().top + window.scrollY;
    var distance = Math.max(0, window.scrollY - rootTop);
    var compact = distance > 60;
    var progress = Math.max(0, Math.min(1, (distance - 90) / 130));
    root.classList.toggle('is-search-compact', compact);
    app.compact.classList.toggle('is-round', progress > 0.65);
    app.compact.style.width = Math.round(190 - (146 * progress)) + 'px';
    root.style.setProperty('--gettmi-search-compact-progress', progress.toFixed(3));
  }

  window.addEventListener('scroll', function () {
    if (state.scrollFrame) return;
    state.scrollFrame = window.requestAnimationFrame(updateCompactSearch);
  }, { passive: true });

  var endObserver = new IntersectionObserver(function (entries) {
    if (entries.some(function (entry) { return entry.isIntersecting; })) loadMore();
  }, { rootMargin: '0px 0px 240px 0px' });
  endObserver.observe(app.end);

  updateComposer();
  try {
    app.verbHint.hidden = window.sessionStorage.getItem('gettmi.search.verbHintSeen.v1') === '1';
  } catch (error) {
    app.verbHint.hidden = false;
  }
  updateBrowseLabel();
  updateEnd();
  updateCompactSearch();
  paintFavourites();
  hydrateTrending();
  warmPhrases();

  if (state.term) runSearch(state.term);
})();
